import script from "./IfaSummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IfaSummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./IfaSummaryTable.vue?vue&type=style&index=0&id=0cd98650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd98650"]])

export default __exports__